import QueryString from "query-string";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useMeCore } from "../../../../cores/me";
import { useMercadolibreCore } from "../../../../cores/mercadolibre";
import { mercadolibreOAuthStorage } from "../../../../cores/mercadolibre/mercadolibreOAuth.storage";
import { useRouterCore } from "../../../../cores/router";
import { LoadingSpinnerWembii } from "../../LoadingSpinnerWembii";

export default function MercadolibrePopUp() {
  const { search } = useLocation();
  const { bind } = useMercadolibreCore();
  const { company, getMeSocialSettings } = useMeCore();
  const { goToSocial } = useRouterCore();

  useEffect(() => {
    let cancelled = false;

    const completeOAuth = async () => {
      const { code, state } = QueryString.parse(search);

      if (!mercadolibreOAuthStorage.isValidState(state)) {
        mercadolibreOAuthStorage.clear();
        toast.error("La sesión de Mercado Libre expiró. Intenta conectar de nuevo.");
        if (!cancelled) goToSocial();
        return;
      }

      if (code && company?.id) {
        await bind(company.id, code as string, () => {
          getMeSocialSettings(company.id);
        });
      } else {
        mercadolibreOAuthStorage.clear();
      }

      if (!cancelled) {
        goToSocial();
      }
    };

    completeOAuth();

    return () => {
      cancelled = true;
    };
  }, [search, company, bind, goToSocial, getMeSocialSettings]);

  return <LoadingSpinnerWembii active />;
}
